import apiRequest from "./apiRequest";

const dashboardReportsApi = {
    manualRefresh: async (token) => 
        apiRequest('/api/dashboard/refresh/manual', 'PUT', token),

    getUserMonthlyActivity: async (token) => 
        apiRequest('/api/dashboard/users/monthly-activity', 'GET', token),
    
    getUserMonthlyActivityByUserId: async (userId,token) => 
        apiRequest(`/api/dashboard/users/monthly-activity/${userId}`, 'GET', token),
    
    getAllTasksStatusById: async (accountId,token) => 
        apiRequest(`/api/dashboard/tasks/status/${accountId}`, 'GET', token),
    
    getAllTasksStatus: async (token) => 
        apiRequest(`/api/dashboard/tasks/status/all`, 'GET', token),
    
    getTasksClosuresByAccountId: async (accountId,token) => 
        apiRequest(`/api/dashboard/tasks/closures/${accountId}`, 'GET', token),
    
       getAllTaskClosures: async (token) => 
        apiRequest('/api/dashboard/tasks/closures/all', 'GET', token),

    getLastRefreshTime: async (token) => 
        apiRequest('/api/dashboard/refresh/last', 'GET', token),

    getMetricsAccount: async (token) => 
        apiRequest('/api/dashboard/metrics/accounts', 'GET', token),

    getMetricsAccountById: async (accountId,token) => 
        apiRequest(`/api/dashboard/metrics/account/${accountId}`, 'GET', token),
   
    getListByEntity: async (entityType,entityId,token) => 
        apiRequest(`/api/dashboard/list/${entityType}/${entityId}`, 'GET', token),
 
    getAccountReport: async (accountId,token) => 
        apiRequest(`/api/dashboard/account/${accountId}`, 'GET', token),

    
    
   
   
};

export default dashboardReportsApi;
